import { z } from 'zod'

export const requestDispatchSimulationAllStoresByEmailSchema = z.object({
  emails: z.array(z.email()),
  sendToPilotage: z.boolean(),
  referenceDate: z.iso.datetime({ offset: true }).optional(),
})

export type RequestDispatchSimulationAllStoresByEmailInput = z.infer<
  typeof requestDispatchSimulationAllStoresByEmailSchema
>
